var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmergencyCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 298.59,
    y: 41.23,
    width: 112.38,
    height: 117.15,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.98,
    y: 41.23,
    width: 112.38,
    height: 117.15,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.39,158.41H290.94V41.19H403.39ZM291,158.34H403.32V41.26H291Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.08,
    y: 56.98,
    width: 82.17,
    height: 85.65,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.08,143.2a13.26,13.26,0,0,1-2,2.36c-1.31,1.38-3.15,3.25-5.22,5.29s-4,3.85-5.37,5.14a13.18,13.18,0,0,1-2.37,2,12.67,12.67,0,0,1,2-2.35c1.31-1.39,3.16-3.26,5.23-5.31s4-3.86,5.38-5.14A12.84,12.84,0,0,1,306.08,143.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.25,143a12.86,12.86,0,0,1,2.36,2c1.38,1.31,3.26,3.15,5.29,5.22s3.85,4,5.14,5.37a13.18,13.18,0,0,1,2,2.37,12.67,12.67,0,0,1-2.35-2c-1.38-1.31-3.26-3.16-5.31-5.23s-3.86-4-5.14-5.38A12.84,12.84,0,0,1,388.25,143Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,57.21a13.51,13.51,0,0,1,2-2.36c1.31-1.39,3.16-3.26,5.22-5.3s4-3.85,5.37-5.13a13,13,0,0,1,2.38-2,13.38,13.38,0,0,1-2,2.34c-1.31,1.39-3.16,3.27-5.23,5.31s-4,3.86-5.38,5.15A12.8,12.8,0,0,1,388,57.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.86,57.42a13.51,13.51,0,0,1-2.36-2c-1.38-1.31-3.26-3.16-5.29-5.22s-3.86-4-5.14-5.37a13,13,0,0,1-2-2.38,13.62,13.62,0,0,1,2.35,2c1.38,1.31,3.26,3.16,5.3,5.23s3.86,4,5.15,5.38A12.8,12.8,0,0,1,305.86,57.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,142.63s0-.15,0-.42,0-.68,0-1.19c0-1.08,0-2.62,0-4.63,0-4-.05-10-.08-17.45,0-15-.1-36.37-.16-62l.31.31-81.93.05h0l.37-.36c0,31.43,0,60.85-.05,85.65l-.32-.31,59.33.16,16.67.08,4.41,0,1.14,0,.39,0-.36,0h-1.1l-4.35,0-16.6.08-59.53.16h-.31v-.31c0-24.8,0-54.22,0-85.65v-.37h.37l81.93,0h.32V57c-.07,25.67-.12,47.11-.16,62.16,0,7.46-.06,13.34-.08,17.38,0,2,0,3.51,0,4.57,0,.49,0,.87,0,1.16A1.52,1.52,0,0,1,388,142.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.46,
    y: 86.09,
    width: 27.42,
    height: 27.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.11,351c6.12-3.16,13.34-3.57,20.14-2.45,3.65.6,7.46,1.7,9.95,4.44s2.95,7.58.1,9.94c-1.7,1.4-4.07,1.61-6.27,1.59-5.33-.07-11.24-1-15.49,2.2-2.43,1.83-4,4.87-6.94,5.77s-6-.8-7.55-3.36a11.66,11.66,0,0,1-.85-8.65A13.21,13.21,0,0,1,430.11,351Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.07,323.87c3.75,5.35,11,3.58,14.4.32s4.81-8,6.1-12.52c3-10.31,6-21.13,3.76-31.63a17.64,17.64,0,0,0-4-8.6c-2.21-2.33-5.6-3.72-8.7-2.9-3.67,1-6,4.57-7.6,8a75.39,75.39,0,0,0-7.46,32.36c0,5.21.6,10.68,3.54,15",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,347.05c4.07-4.83,4.84-11.87,3-17.92s-5.9-11.19-10.61-15.39a57.24,57.24,0,0,0-19-11.21,20.17,20.17,0,0,0-8.55-1.45,9,9,0,0,0-7.17,4.34c-2,3.81-.08,8.44,2,12.21a146.81,146.81,0,0,0,12.48,19c3.75,4.82,8,9.58,13.73,11.76s11.62,1.92,14.65-2",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.82,404.58a11.91,11.91,0,0,0,.34-2.43c.17-1.77.38-4,.64-6.63a97.48,97.48,0,0,1,1.49-9.74,76.41,76.41,0,0,1,3.54-11.48,42.16,42.16,0,0,1,5.87-10.4,21.89,21.89,0,0,1,7.41-6.16,20.55,20.55,0,0,1,6.25-1.94,11.17,11.17,0,0,0,2.42-.36,12.05,12.05,0,0,0-2.47,0,18.82,18.82,0,0,0-6.51,1.69,22,22,0,0,0-7.82,6.22,41.48,41.48,0,0,0-6.08,10.6,70.5,70.5,0,0,0-3.51,11.68,83.65,83.65,0,0,0-1.3,9.85c-.21,2.82-.29,5.1-.32,6.68A10.89,10.89,0,0,0,415.82,404.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.27,399.48a4.32,4.32,0,0,0,.07-1.13c0-.85,0-1.92,0-3.23,0-2.8,0-6.85.14-11.85.25-10,1.11-20.78,2.78-36,1.57-14.27,3.69-30.89,5.92-41.69.48-2.45,1-4.67,1.41-6.6s.81-3.61,1.16-5l.76-3.13a4.22,4.22,0,0,0,.19-1.12,5.65,5.65,0,0,0-.39,1.06q-.36,1.22-.93,3.09c-.42,1.34-.84,3-1.33,4.94s-1,4.13-1.56,6.58a365.71,365.71,0,0,0-6.23,38.69c-1.67,15.21-2.42,29.06-2.48,39.1-.06,5,0,9.07.17,11.87.08,1.31.15,2.38.2,3.23A5.07,5.07,0,0,0,416.27,399.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.54,388.26a21.21,21.21,0,0,0,0-3.37c-.13-2.17-.42-5.3-1-9.13a121,121,0,0,0-3-13.3A108.9,108.9,0,0,0,406,346.72c-4.61-11-10.88-19.9-16.33-25.44a43,43,0,0,0-3.84-3.57c-.59-.5-1.12-1-1.65-1.39l-1.49-1a22.16,22.16,0,0,0-2.83-1.81c-.17.22,4,2.68,9.29,8.29A88.19,88.19,0,0,1,405,347.12a125.56,125.56,0,0,1,5.6,15.59c1.46,4.89,2.42,9.38,3.16,13.17s1.09,6.9,1.34,9A21.92,21.92,0,0,0,415.54,388.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.52 419.89 393.19 456.57 440.31 456.57 442.99 419.89 390.52 419.89",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.97,
    y: 405.43,
    width: 62.64,
    height: 14.46,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.97 455.16 385.97 459.17 388.91 459.17 447.58 459.17 447.58 455.16 385.97 455.16",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.8 466.22 388.91 459.17 445.33 459.17 441.97 466.22 391.8 466.22",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.11,431.88s-.06.12-.21.33l-.71.94-2.74,3.51-.13.16-.11-.17-6.75-9.32h.39l-6.64,9.4L425,437l-.23-.28-7.87-9.36h.45l-.43.54-7,8.83-.24.29-.21-.3-6.65-9.4.39,0L395,436.67l-.15.16-.11-.18-2.56-4.31c-.27-.46-.48-.84-.66-1.14a2.13,2.13,0,0,1-.2-.41s.11.12.28.36l.73,1.11,2.68,4.22-.25,0c2.09-2.46,4.83-5.66,8.05-9.43l.2-.24.18.25,6.71,9.36h-.46l7-8.84c.15-.19.3-.37.43-.55l.23-.28.23.28,7.85,9.39h-.44c2.42-3.38,4.68-6.52,6.7-9.35l.2-.28.19.28c2.66,3.79,4.91,7,6.6,9.43h-.24l2.86-3.42.76-.89C442,432,442.1,431.87,442.11,431.88Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.65,419.65c0,.16-11.81.29-26.37.29s-26.37-.13-26.37-.29,11.8-.3,26.37-.3S443.65,419.48,443.65,419.65Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446,459.56c0,.17-12.84.3-28.66.3s-28.66-.13-28.66-.3,12.83-.29,28.66-.29S446,459.4,446,459.56Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.9 422.35 40.9 465.9 104.59 465.9 174.84 465.9 174.84 422.35 40.9 422.35",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "35.28 410.18 35.28 422.35 179.52 422.35 179.52 410.18 104.59 410.18 35.28 410.18",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.4 465.9 174.84 465.9 174.84 422.35 179.52 422.35 179.52 410.18 104.59 410.18 104.59 421.23 107.4 465.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.63,
    y: 429.38,
    width: 27.16,
    height: 6.56,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.14,
    y: 444.13,
    width: 34.88,
    height: 13.84,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.51 366.68 61.51 410.23 125.19 410.23 195.44 410.23 195.44 366.68 61.51 366.68",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.89 354.5 55.89 366.68 200.13 366.68 200.13 354.5 125.19 354.5 55.89 354.5",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128 410.23 195.44 410.23 195.44 366.68 200.13 366.68 200.13 354.5 125.19 354.5 125.19 365.55 128 410.23",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.24,
    y: 373.7,
    width: 27.16,
    height: 6.56,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.74,
    y: 388.46,
    width: 34.88,
    height: 13.84,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.87,466.22c0,.15-101.58.26-226.86.26s-226.88-.11-226.88-.26S124.69,466,250,466,476.87,466.08,476.87,466.22Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.65,389.42l-117-.06a25.27,25.27,0,0,1-25.48-25.05l0-288.17a25.27,25.27,0,0,1,25.51-25l117,.07c14.08,0,25.48,11.22,24.51,25l-.06,288.17C225.15,378.22,213.73,389.43,199.65,389.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.79,59.42H177.1a5.64,5.64,0,0,0-5.51,5.76v4.11A5.64,5.64,0,0,1,166.08,75l-44.23,0a5.63,5.63,0,0,1-5.5-5.76V65.13a5.64,5.64,0,0,0-5.51-5.76H83A17.86,17.86,0,0,0,65.13,77.21l0,286.37a17.85,17.85,0,0,0,17.84,17.86l116.8.07a17.86,17.86,0,0,0,17.86-17.85l.06-286.38A17.86,17.86,0,0,0,199.79,59.42Z",
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.47,92.39c0,.08-3.15.17-7,.2s-7,0-7-.09,3.15-.17,7-.2S206.47,92.31,206.47,92.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.5,96c0,.08-3.15.17-7,.2s-7,0-7-.09,3.15-.17,7-.2S206.5,95.9,206.5,96Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.53,99.59c0,.08-3.15.17-7,.2s-7,0-7-.09,3.15-.17,7-.2S206.53,99.5,206.53,99.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.56,103.81l.3,0,.81,0,3-.08-.08.09c0-.67,0-1.4,0-2.18,0-.4,0-.79,0-1.25a1.16,1.16,0,0,1,1-.93c.48,0,.91,0,1.43,0a1.18,1.18,0,0,1,1,1.16q0,1.53,0,3.18l-.14-.14,3.79,0-.14.15c0-1.53,0-3.1,0-4.72,0-.4,0-.8,0-1.2a1.26,1.26,0,0,0-.54-.9l-1.65-1.63-1.6-1.58-.78-.76a1.78,1.78,0,0,0-.78-.59,1,1,0,0,0-.87.17c-.23.19-.47.47-.7.69L81.2,94.57c-.86.89-1.75,1.7-2.4,2.47a2.7,2.7,0,0,0-.19,1.41v1.34c0,.82,0,1.54,0,2.15s0,1,0,1.38a2.86,2.86,0,0,1,0,.49s0-.15,0-.45,0-.82,0-1.36,0-1.34,0-2.17c0-.42,0-.88,0-1.36,0-.24,0-.49,0-.74a1.58,1.58,0,0,1,.21-.79c.7-.86,1.54-1.62,2.4-2.54L82.37,93a10,10,0,0,1,.73-.72,1.27,1.27,0,0,1,1.1-.22,2.05,2.05,0,0,1,.91.65l.78.76,1.6,1.57,1.66,1.63a3.2,3.2,0,0,1,.42.46,1.13,1.13,0,0,1,.2.64c0,.4,0,.8,0,1.21,0,1.61,0,3.19,0,4.72v.14h-.15l-3.78,0h-.14v-.14c0-1.1,0-2.16,0-3.17a.9.9,0,0,0-.77-.92c-.43,0-.95,0-1.37,0a.94.94,0,0,0-.82.74c0,.38,0,.82,0,1.21v2.26h-.09l-3,0h-.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.44,
    cy: 319.14,
    r: 21.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.1,324.14l5.43-1.28a1.47,1.47,0,0,0,1.14-1.44V320.3s-.23-1.9,1.57-2c1.28-.09,9.45,0,9.45,0s2.15,0,2.12,1.65v1.63a1.28,1.28,0,0,0,.9,1.22l5.89,1.78a1.27,1.27,0,0,0,1.54-.73l.75-1.82a2.36,2.36,0,0,0,.19-1.05,5,5,0,0,0-1-2.72c-1.17-1.5-6.68-5-17.18-4.53-10,.48-12.18,4.7-12.75,5.71a4.25,4.25,0,0,0-.19,2.81l.44,1A1.48,1.48,0,0,0,135.1,324.14Z",
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 148.44,
    cy: 249.44,
    r: 15.07,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 144.32,
    cy: 249.46,
    r: 1.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.19,249.46a1.75,1.75,0,1,1-1.75-1.75A1.75,1.75,0,0,1,150.19,249.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.31,249.46a1.76,1.76,0,1,1-1.75-1.75A1.75,1.75,0,0,1,154.31,249.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.07,245.28a1.75,1.75,0,1,1-1.75-1.76A1.75,1.75,0,0,1,146.07,245.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.19,245.28a1.75,1.75,0,1,1-1.75-1.76A1.75,1.75,0,0,1,150.19,245.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.31,245.28a1.76,1.76,0,1,1-1.75-1.76A1.75,1.75,0,0,1,154.31,245.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.07,253.6a1.75,1.75,0,1,1-1.75-1.75A1.75,1.75,0,0,1,146.07,253.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.19,253.6a1.75,1.75,0,1,1-1.75-1.75A1.75,1.75,0,0,1,150.19,253.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.31,253.6a1.76,1.76,0,1,1-1.75-1.75A1.75,1.75,0,0,1,154.31,253.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 105.18,
    cy: 249.44,
    r: 15.07,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M98.11,247.47V251a.27.27,0,0,0,.27.27h2a.27.27,0,0,1,.17.06l3.07,2.4a.27.27,0,0,0,.44-.22v-8.33a.27.27,0,0,0-.43-.23l-3,2.14a.33.33,0,0,1-.16.05H98.38A.28.28,0,0,0,98.11,247.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.74,255.46a.33.33,0,0,1-.23-.09.34.34,0,0,1,0-.48A8.14,8.14,0,0,0,111.9,249a8,8,0,0,0-2.39-5,.35.35,0,1,1,.46-.52,8.55,8.55,0,0,1,2.62,5.47,8.82,8.82,0,0,1-2.59,6.38A.38.38,0,0,1,109.74,255.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.84,253.78a.34.34,0,0,1-.25-.11.35.35,0,0,1,0-.49,5,5,0,0,0,1.84-3.69,6.23,6.23,0,0,0-1.84-4,.35.35,0,0,1,0-.49.34.34,0,0,1,.48,0,6.83,6.83,0,0,1,2.06,4.51,5.69,5.69,0,0,1-2.06,4.2A.3.3,0,0,1,107.84,253.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.15,252a.37.37,0,0,1-.24-.1.34.34,0,0,1,0-.49c2.12-2.1.07-4.48,0-4.58a.36.36,0,0,1,0-.49.35.35,0,0,1,.49,0s2.57,3,0,5.53A.35.35,0,0,1,106.15,252Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 187.99,
    cy: 249.44,
    r: 15.07,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.09,254.65a.47.47,0,0,1-.47-.46v-9.5a.47.47,0,0,1,.93,0v9.5A.47.47,0,0,1,188.09,254.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.6,249.9h-9.21a.47.47,0,0,1-.47-.46.46.46,0,0,1,.47-.46h9.21a.45.45,0,0,1,.46.46A.46.46,0,0,1,192.6,249.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.68,147.85q6.18,6.66,6.18,19.17a32.39,32.39,0,0,1-3.31,15.2,22.52,22.52,0,0,1-9.35,9.6,28.63,28.63,0,0,1-13.92,3.28,33.4,33.4,0,0,1-8-.93,21.29,21.29,0,0,1-6.48-2.65l4.47-8.86a16.85,16.85,0,0,0,9.75,2.61q6.63,0,10.5-3.91t4.17-11.28q-4.68,4.69-13,4.69a20.35,20.35,0,0,1-9.09-2,15.87,15.87,0,0,1-6.48-5.7,15.34,15.34,0,0,1-2.38-8.52,16.21,16.21,0,0,1,2.61-9.16,16.82,16.82,0,0,1,7.11-6.07,23.11,23.11,0,0,1,10-2.13Q123.5,141.18,129.68,147.85Zm-9.79,15.71a7.63,7.63,0,0,0,.07-11.21,9.63,9.63,0,0,0-6.66-2.16,9.29,9.29,0,0,0-6.29,2.09,7.07,7.07,0,0,0-2.42,5.66,7.19,7.19,0,0,0,2.42,5.7,10.68,10.68,0,0,0,12.88-.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.33,142.08v52.13H149.27V151.76H138.84v-9.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.52,142.08v52.13H178.46V151.76H168v-9.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.71,215.22V217H90.25v-8h6.31v1.76H92.5v1.36h3.58v1.7H92.5v1.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.25,217l0-4.27-2.07,3.48h-1l-2.06-3.36V217H98v-8h1.87l2.83,4.65,2.76-4.65h1.88l0,8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.42,215.22V217H109v-8h6.32v1.76h-4.06v1.36h3.57v1.7h-3.57v1.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.2,214.84H119V217h-2.28v-8h3.68a4.63,4.63,0,0,1,1.9.36,2.77,2.77,0,0,1,1.24,1,2.84,2.84,0,0,1,.44,1.58,2.81,2.81,0,0,1-.41,1.52,2.66,2.66,0,0,1-1.17,1L124.1,217h-2.44Zm1.08-3.8a1.54,1.54,0,0,0-1.06-.32H119v2.36h1.26a1.6,1.6,0,0,0,1.06-.3,1.08,1.08,0,0,0,.36-.87A1.07,1.07,0,0,0,121.28,211Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.59,212.78h2v3.34a5.32,5.32,0,0,1-1.59.76,6.46,6.46,0,0,1-1.79.26,4.91,4.91,0,0,1-2.28-.53,4.07,4.07,0,0,1-1.59-1.49,4.4,4.4,0,0,1,0-4.33,4.11,4.11,0,0,1,1.6-1.49,5,5,0,0,1,2.32-.53,5.19,5.19,0,0,1,2,.38,3.93,3.93,0,0,1,1.5,1.09l-1.45,1.31a2.56,2.56,0,0,0-2-.89,2.15,2.15,0,0,0-2.3,2.3,2.47,2.47,0,0,0,.29,1.19,2,2,0,0,0,.8.81,2.34,2.34,0,0,0,1.19.3,2.87,2.87,0,0,0,1.23-.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.51,215.22V217h-6.46v-8h6.32v1.76H136.3v1.36h3.58v1.7H136.3v1.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.44,208.93v8h-1.87L144,212.69V217h-2.23v-8h1.87l3.56,4.29v-4.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.79,216.61a4,4,0,0,1-1.58-1.49,4.14,4.14,0,0,1,1.58-5.82,4.84,4.84,0,0,1,2.27-.53,5,5,0,0,1,2,.39,3.82,3.82,0,0,1,1.47,1.13l-1.45,1.31a2.38,2.38,0,0,0-1.9-.94,2.36,2.36,0,0,0-1.17.28,2.05,2.05,0,0,0-.79.81,2.73,2.73,0,0,0,0,2.41,2,2,0,0,0,.79.81,2.36,2.36,0,0,0,1.17.29,2.39,2.39,0,0,0,1.9-.95l1.45,1.31a3.73,3.73,0,0,1-1.47,1.13,5,5,0,0,1-2,.39A4.84,4.84,0,0,1,152.79,216.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.82,214.09V217h-2.28v-2.92l-3.07-5.13h2.4l1.91,3.2,1.91-3.2h2.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.57,216.61a4,4,0,0,1-1.59-1.49,4.4,4.4,0,0,1,0-4.33,4.08,4.08,0,0,1,1.59-1.49,4.81,4.81,0,0,1,2.27-.53,4.91,4.91,0,0,1,2,.39,3.82,3.82,0,0,1,1.47,1.13l-1.45,1.31a2.37,2.37,0,0,0-1.9-.94,2.41,2.41,0,0,0-1.17.28,2.05,2.05,0,0,0-.79.81,2.73,2.73,0,0,0,0,2.41,2,2,0,0,0,.79.81,2.42,2.42,0,0,0,1.17.29,2.38,2.38,0,0,0,1.9-.95l1.45,1.31a3.73,3.73,0,0,1-1.47,1.13,4.91,4.91,0,0,1-2,.39A4.81,4.81,0,0,1,172.57,216.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.57,215.42h-3.41l-.63,1.56h-2.32l3.55-8H184l3.57,8H185.2Zm-.67-1.68-1-2.58-1,2.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.21,208.93h2.28v6.25h3.84V217h-6.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.23,208.93h2.28v6.25h3.84V217h-6.12Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "405.05 85.38 384.77 70.52 382.18 95.01 356.39 97.71 376.2 117.51 361.04 131.96 382.51 133.54 385 152.81 401.99 138.46 425.01 152.81 431.44 129.06 456.86 125.49 434.58 109.64 446.59 88.54 427.25 92.96 421.81 67.01 405.05 85.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.05,85.38l1.1-1.25c.74-.81,1.82-2,3.23-3.58l12.34-13.62.17-.19.05.25c1.5,7.11,3.36,15.89,5.48,25.94l-.21-.14,19.34-4.45.44-.1-.22.4-12,21.11-.07-.29L457,125.29l.49.35-.6.09-25.41,3.58.21-.18-6.43,23.75-.09.34-.3-.19L407.12,142l-5.27-3.28.31,0-17,14.35-.36.3-.06-.47q-1.28-9.81-2.49-19.27l.23.22L361,132.2l-.55,0,.4-.38L376,117.35v.33L356.25,97.86l-.31-.31.43,0,25.79-2.67L382,95c1-9.58,1.91-17.72,2.64-24.5l0-.21.17.13,15,11.08,3.88,2.88,1.32,1s-.44-.3-1.32-.93l-3.9-2.82-15.14-11,.2-.09c-.7,6.78-1.55,14.92-2.54,24.5l0,.14-.14,0-25.77,2.73.12-.35,19.82,19.78.17.17-.18.16-15.14,14.46-.15-.42,21.47,1.57h.2l0,.21q1.22,9.44,2.5,19.27l-.42-.17,17-14.35.15-.12.16.1,5.26,3.28,17.76,11.07-.39.15c2.21-8.17,4.38-16.18,6.44-23.75l0-.16.17,0,25.41-3.56-.1.44-22.27-15.87-.16-.12.1-.17,12-21.09.22.3-19.35,4.4-.17,0,0-.18-5.39-26,.22.06L409.42,80.68l-3.26,3.52C405.43,85,405.05,85.38,405.05,85.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.82,94.42l-1.34,19.42a3.17,3.17,0,0,1-3,2.93h0a3.15,3.15,0,0,1-3.3-2.82l-2-19.54a2.47,2.47,0,0,1,2.51-2.73l4.73.09A2.48,2.48,0,0,1,401.82,94.42Z",
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.48,125.84a4.74,4.74,0,1,0,3-6A4.73,4.73,0,0,0,392.48,125.84Z",
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.88,94.42l-1.35,19.42a3.15,3.15,0,0,1-3,2.93h0a3.14,3.14,0,0,1-3.3-2.82l-2.05-19.54a2.47,2.47,0,0,1,2.51-2.73l4.74.09A2.48,2.48,0,0,1,417.88,94.42Z",
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.53,125.84a4.74,4.74,0,1,0,3-6A4.75,4.75,0,0,0,408.53,125.84Z",
    style: {
      fill: "#F68989"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.1,338.55a5.82,5.82,0,0,0-2.77-4.6c-24.59-16.28-43.13-52.36-45-82.91-.05-1.74-.1-3.5-.16-5.28v0h0c-1.54-45.93-8-98.8-13.63-110.77-12.05-25.47-46.78-28.53-46.78-28.53-47.95-3.43-56.51,33.42-61.35,67-3,20.87-14.61,95.42-14.61,95.42l8.81,3.41C227,303,250.37,327.89,280.76,339.33c8.84,3.33,16.33,4.67,19.84,1.81a120.65,120.65,0,0,0,50.45,30.63c7.75,2.35,15.86,3.93,23.92,3.17,5.24-.49,10.76-2.22,13.88-6.45a12,12,0,0,0-10.32-19.14C380.35,343.45,392.31,345.19,392.1,338.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.89,247.86s17.53-7.53,26.58-9.24,72.29-18,72.29-18l-65.27-55.93,14.4-17.52s48.48,28.93,82.95,52a4.86,4.86,0,0,1,.65.44c19.6,15.43,12.74,42.31-7.39,54.94-10,6.29-54,25.24-62.47,29.39-17,8.28-16.75,8-16.75,8Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.14,120l-3-2.86-32.42,13.06a9,9,0,0,0-8.54,8.76l.28,105.62c0,7.17,1.39,13.37,5.72,19.08l4.55,6c10.38,13.71,31.74,12.58,40-2.52a11.59,11.59,0,0,0,1.14-2.73,19.92,19.92,0,0,0,.48-2.37c1-8.49,1-15.86,1-15.86.58-9.33.77-13.16.77-13.07s19.86-2.29,25.23-27.77c2.67-12.68,2.16-30.12,1.41-47.28C325.7,134.33,309.23,120,290.14,120Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.13,175a3.29,3.29,0,0,1-3.34,3.16,3.16,3.16,0,0,1-3.25-3.14,3.31,3.31,0,0,1,3.34-3.17A3.16,3.16,0,0,1,288.13,175Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.3,175.94a3.3,3.3,0,0,1-3.35,3.17,3.16,3.16,0,0,1-3.24-3.14,3.29,3.29,0,0,1,3.34-3.17A3.16,3.16,0,0,1,320.3,175.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.35,164.87c-.43.41-2.83-1.56-6.38-1.73s-6.23,1.47-6.59,1c-.18-.2.27-1,1.45-1.73a9.05,9.05,0,0,1,5.3-1.34,8.69,8.69,0,0,1,5.05,1.91C323.23,163.89,323.56,164.69,323.35,164.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.37,165.24c-.47.36-2.66-1.85-6.17-2.38s-6.35.83-6.66.34c-.16-.22.36-.93,1.62-1.57a9.09,9.09,0,0,1,5.41-.8,8.67,8.67,0,0,1,4.83,2.43C287.35,164.25,287.6,165.08,287.37,165.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.76,191.05c0-.21,2.21-.48,5.81-.75.91-.05,1.77-.19,2-.8a4.7,4.7,0,0,0-.47-2.71l-2.33-7c-3.23-10-5.52-18.21-5.11-18.33s3.34,7.87,6.57,17.88q1.15,3.69,2.22,7.06c.29,1,.82,2.24.29,3.58a2.3,2.3,0,0,1-1.56,1.25,6.3,6.3,0,0,1-1.55.13C302,191.34,299.76,191.25,299.76,191.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.1,233.13a65.47,65.47,0,0,1-33.94-10.91s7.76,18.22,33.59,17.11Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.86,151.43c.13-1,3.68-1.36,7.63-2.78s7-3.28,7.71-2.56c.33.35,0,1.36-1.15,2.58a14.14,14.14,0,0,1-11.69,4.07C275.74,152.48,274.82,151.91,274.86,151.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,151.4c-.67.77-3.07-.19-6-.38s-5.46.27-6-.6c-.23-.42.21-1.21,1.33-1.91a8.68,8.68,0,0,1,9.65.78C321,150.17,321.26,151,321,151.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.82,184.05s18.16,5.65,28.44-39.17c3.51-15.32,17.72-27.73,17.72-27.73l-5.76-1.74S251.41,125.5,250.8,126s-9,18.52-9,18.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.3,182.38c.09-1.91-1.9-6.54-3.77-6.93-5-1-14.12-1.09-14.85,11.72-1,17.51,16.79,14.9,16.85,14.4S251,189,251.3,182.38Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.56,194.63c-.07-.06-.32.2-.85.41a3,3,0,0,1-2.28-.09c-1.81-.78-3.2-3.81-3.11-7a10.29,10.29,0,0,1,1.1-4.32,3.53,3.53,0,0,1,2.43-2.21,1.55,1.55,0,0,1,1.75.94c.21.5.08.85.17.88s.39-.27.29-1a2,2,0,0,0-.62-1.14,2.35,2.35,0,0,0-1.67-.54,4.31,4.31,0,0,0-3.34,2.53A10.42,10.42,0,0,0,237.1,188c-.09,3.53,1.53,6.93,4,7.81a3.27,3.27,0,0,0,2.82-.31C244.5,195.05,244.62,194.67,244.56,194.63Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.14,175.48c0-.06,1-.07,2.62-.53a15.81,15.81,0,0,0,6.24-3.62,21.85,21.85,0,0,0,3.25-3.81,30,30,0,0,0,2.65-5.12,110.56,110.56,0,0,0,3.77-12.73,132,132,0,0,1,4-12.72,72.2,72.2,0,0,1,4.56-9.89,53.29,53.29,0,0,1,4-6.16c.52-.69,1-1.19,1.26-1.55a3,3,0,0,1,.46-.51,4.33,4.33,0,0,1-.39.57c-.26.37-.69.89-1.18,1.6a59.59,59.59,0,0,0-3.87,6.21,75.78,75.78,0,0,0-4.45,9.88c-1.44,3.83-2.75,8.13-4,12.69a105.72,105.72,0,0,1-3.83,12.77,28.29,28.29,0,0,1-2.72,5.17,21.36,21.36,0,0,1-3.35,3.84,15.41,15.41,0,0,1-6.41,3.55A9.85,9.85,0,0,1,259.14,175.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.21,250.19a3.9,3.9,0,0,1-.19-.84c-.11-.62-.26-1.44-.45-2.49L233,237.35l.42-.06c.09.64.19,1.34.29,2.07l0-.07.37.79-.44.16A168.34,168.34,0,0,1,228,212.05a173.19,173.19,0,0,1-1.07-18.23c.06-6.4,0-13.2,1.73-20a31.73,31.73,0,0,1,3.19-8,43.18,43.18,0,0,1,4.84-6.75c3.56-4.11,7.4-7.65,10.9-11.16l18.8-18.5c5.34-5.21,9.68-9.44,12.72-12.42l3.49-3.34.92-.86a1.5,1.5,0,0,1,.34-.27,2.06,2.06,0,0,1-.28.33l-.86.91-3.39,3.45-12.54,12.61-18.68,18.61c-3.49,3.53-7.32,7.09-10.82,11.15A34.4,34.4,0,0,0,229.44,174c-1.68,6.64-1.66,13.41-1.73,19.78a175.94,175.94,0,0,0,6.36,46.3l-.44.16c-.12-.27-.25-.55-.35-.79l0,0v0c-.09-.73-.18-1.44-.26-2.07l.42-.07c.59,4.08,1.05,7.29,1.38,9.54.14,1.06.25,1.89.33,2.51A5.08,5.08,0,0,1,235.21,250.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.42,169.24a2.64,2.64,0,0,1,.31-.74l1-2.06c.89-1.78,2.29-4.31,4.12-7.36s4.17-6.61,6.93-10.44,6-7.86,9.65-11.92,7.35-7.69,10.84-10.87,6.78-5.86,9.64-8,5.2-3.81,6.88-4.88l1.94-1.24a3.26,3.26,0,0,1,.7-.38,3.24,3.24,0,0,1-.61.52L271,113.22c-1.62,1.15-3.93,2.88-6.72,5.08s-6,4.93-9.49,8.09-7.1,6.84-10.73,10.86-6.84,8.07-9.66,11.83-5.16,7.28-7,10.29-3.36,5.48-4.33,7.22l-1.15,2A3.41,3.41,0,0,1,221.42,169.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.66,244.59l-.07,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.59,244.57l-.18-.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.3,466l-25.11-76.52-2-72.72c-.61-12.54-1.54-30.88-1.54-30.88-8.19-25.62-34.23-47.25-34.23-47.25l-14.78,2.21c-.56,16-25,30.51-42.52,19.91-6.49-4.66-11.48-16.12-11.48-16.12L215.83,259l20.48,146.37s-20.2,37.69-20.2,60.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.41,244.51l-.17,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.24,244.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M234.31,387.93c3.67,9.36,10.88,17.6,20.31,21.08s21,1.51,27.8-5.91c4.17-4.55,6.25-10.63,7.58-16.66a161.18,161.18,0,0,0,2.44-16.08c3.16-27.38,5.46-55,2.93-82.47l-3.74-31.68-10.82,6.1-5,112.82Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M300,240.23s21.73-5.46,39.4-5.93l29.31-7.4,5,52.36L345.72,297.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.26,320.74l-51.45,25.82S182.56,270.2,215.68,259l1.92,10.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.05,255.05s0,.12,0,.34.05.6.08,1c.06.93.15,2.24.25,3.91.22,3.4.48,8.32.79,14.39.61,12.16,1.33,29,2,47.51s1.21,35.37,1.55,47.53c.15,6.06.28,11,.36,14.41,0,1.67.06,3,.07,3.92,0,.42,0,.76,0,1a1.23,1.23,0,0,1,0,.34,1.44,1.44,0,0,1,0-.34q0-.39-.06-1c0-.93-.1-2.24-.17-3.92-.13-3.43-.31-8.34-.53-14.4-.44-12.19-1-29-1.7-47.52s-1.38-35.32-1.85-47.51c-.27-6.06-.48-11-.63-14.4-.07-1.67-.12-3-.16-3.91l0-1A1.18,1.18,0,0,1,347.05,255.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.81,346.56s.06-.05.2-.13l.63-.35,2.44-1.28,9-4.61,29.83-15.06,6.26-3.13-.13.32a67.26,67.26,0,0,0-3.12-7.64c-1.15-2.42-2-4.82-2.91-7.08-1.7-4.53-3.47-8.47-4.91-11.78s-2.58-6-3.31-7.82c-.36-.93-.64-1.65-.81-2.15a4.91,4.91,0,0,1-.24-.75,5,5,0,0,1,.33.72l.89,2.1c.79,1.84,2,4.48,3.45,7.76s3.29,7.23,5,11.76c.88,2.25,1.79,4.64,2.94,7a68.7,68.7,0,0,1,3.15,7.67l.09.22-.21.11-6.25,3.14-29.91,14.92L200.17,345l-2.48,1.2-.65.29A.76.76,0,0,1,196.81,346.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.92,199.65a13.71,13.71,0,0,0-6.7-2.4,4.94,4.94,0,0,0-2.23.23,4,4,0,0,0-2.12,2.55,12,12,0,0,0-.38,3.39,2.72,2.72,0,0,0,.2,1.27,2.44,2.44,0,0,0,2.07,1,15.42,15.42,0,0,0,7.91-1.45",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.35,343.27c10.52,24.44,30.51,49.25,42.83,53.79,18.35,6.76,33.54,3.4,40.58-19s2.52-121.8,2.52-121.8l-30.6-1.75L253,340.18s-3.38-6.65-9.33-17.14",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.49,164.68l-7.71-5.62-1.18-9.66s-13.92.36-14.77-7.1c0,0-8,2.13-7.64-5.76,0,0-4.08-2.77-2.59-5.32s13-6.37,13.66-6.58,8.18-1.81,8.18-1.81l-2.23-2.48-6,.64s-3.62,3.41-6.61,3.83-3.19-.85-3.19-.85-3.41-3.62,1.06-7.25a25.36,25.36,0,0,1,13.21-5.11c3-.21,7,5.54,7,5.54l3.24,5.75s6.4-.85,8.53,4v3.41s4.69-.64,6.61,4.91l1.28,4.9s5.54,7.24,5.75,10.23",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.11,150.4s-.05-.27-.18-.76a13.22,13.22,0,0,0-.88-2.1,54.71,54.71,0,0,0-4.8-7.29v-.05c-.39-1.46-.83-3.12-1.3-4.9v0a7.68,7.68,0,0,0-2.23-3.42,5.88,5.88,0,0,0-4.21-1.35h-.2v-.2c0-1.05,0-2.21,0-3.41V127a6.23,6.23,0,0,0-3.3-3.22,10.42,10.42,0,0,0-5-.69h-.14l-.07-.12-3.26-5.75v0a25.13,25.13,0,0,0-2.32-2.78,11.51,11.51,0,0,0-2.88-2.27,3.36,3.36,0,0,0-1.73-.37c-.63,0-1.26.15-1.9.25a27.51,27.51,0,0,0-3.8,1,22.89,22.89,0,0,0-7.1,3.75,5.84,5.84,0,0,0-2.26,3.23,4.54,4.54,0,0,0,1.1,3.73l.05,0,0,.09a1.11,1.11,0,0,0,.79.59,4,4,0,0,0,1.22.13,6.65,6.65,0,0,0,2.51-.57,18.53,18.53,0,0,0,4.51-3l.34-.31.07-.06h.08l6-.64.13,0,.09.1,2.23,2.49.3.33-.44.1-7.75,1.71a73.36,73.36,0,0,0-7.22,2.62c-1.16.48-2.29,1-3.39,1.55a12.15,12.15,0,0,0-3,1.95,2.22,2.22,0,0,0-.62,1.45,3,3,0,0,0,.46,1.56,8.84,8.84,0,0,0,2.34,2.42l.1.07v.14c0,.49,0,1,.05,1.47a6,6,0,0,0,.32,1.41,3.87,3.87,0,0,0,1.68,2.14,7.44,7.44,0,0,0,5.3.51L311,142l0,.23a5.79,5.79,0,0,0,2.38,4,12.55,12.55,0,0,0,4.09,1.93,29.72,29.72,0,0,0,8.09,1.06h.15v.14c.45,3.83.83,7,1.14,9.67l0-.08,5.7,4.22,1.46,1.1.48.39-.52-.34-1.49-1.05-5.76-4.14,0,0v-.06c-.34-2.64-.74-5.83-1.23-9.65l.17.14a29.75,29.75,0,0,1-8.21-1,12.87,12.87,0,0,1-4.22-2,6.14,6.14,0,0,1-2.56-4.24l.26.18a9.83,9.83,0,0,1-2.82.26,6.22,6.22,0,0,1-2.82-.8,4.35,4.35,0,0,1-1.88-2.37,6.5,6.5,0,0,1-.35-1.51c-.06-.51,0-1-.05-1.55l.1.21a8.94,8.94,0,0,1-2.48-2.57,3.52,3.52,0,0,1-.54-1.81,2.67,2.67,0,0,1,.76-1.78,12.79,12.79,0,0,1,3.11-2.05c1.11-.57,2.25-1.09,3.42-1.57a75,75,0,0,1,7.25-2.65l7.81-1.73-.14.43L320,120.52l.22.09-6,.64.15-.07-.36.32a18.94,18.94,0,0,1-4.64,3.06,7.07,7.07,0,0,1-2.7.6,4.4,4.4,0,0,1-1.39-.15,1.53,1.53,0,0,1-1.15-1l.07.14A5,5,0,0,1,303,120a5.46,5.46,0,0,1,.92-2c.24-.28.46-.56.72-.82s.52-.49.8-.71a23.51,23.51,0,0,1,7.27-3.82,28.13,28.13,0,0,1,3.87-1c.65-.1,1.29-.2,1.95-.25a3.89,3.89,0,0,1,2,.42,12.14,12.14,0,0,1,3,2.37,26.42,26.42,0,0,1,2.36,2.85h0l3.23,5.77-.21-.11a10.67,10.67,0,0,1,5.23.75,6.58,6.58,0,0,1,3.5,3.44V127c0,1.2,0,2.36,0,3.41l-.2-.18a6.23,6.23,0,0,1,4.47,1.47,8.1,8.1,0,0,1,2.3,3.57h0c.46,1.78.88,3.44,1.26,4.9l0,0a51.24,51.24,0,0,1,4.71,7.39,12.18,12.18,0,0,1,.83,2.14A4.15,4.15,0,0,1,351.11,150.4Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.4,154.32c-.06.05-.57-.47-1.52-1.16a17.2,17.2,0,0,0-4-2.12,35.12,35.12,0,0,0-4.4-1.35c-1.15-.21-1.89-.19-1.9-.28a4.42,4.42,0,0,1,1.95-.08,22.68,22.68,0,0,1,4.53,1.22,13.86,13.86,0,0,1,4.09,2.32A4.3,4.3,0,0,1,337.4,154.32Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.66,140.29a4.51,4.51,0,0,1-1.16.14l-3.16.18c-2.67.13-6.36.27-10.43.4l-5.75.15a41,41,0,0,0-4.65.27,18.36,18.36,0,0,0-3.08.6c-.7.22-1.07.41-1.09.37a2.93,2.93,0,0,1,1-.56,15,15,0,0,1,3.08-.78,38,38,0,0,1,4.7-.38l5.75-.2c4.07-.12,7.76-.2,10.43-.24h3.16A6.06,6.06,0,0,1,339.66,140.29Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.24,131.32a4.79,4.79,0,0,1-1.17.24l-3.21.48c-2.72.4-6.46,1-10.57,1.75s-7.82,1.55-10.5,2.14l-3.17.7a5.81,5.81,0,0,1-1.18.2,4.6,4.6,0,0,1,1.13-.4c.73-.22,1.81-.51,3.14-.86,2.66-.68,6.36-1.53,10.48-2.3s7.89-1.29,10.62-1.59c1.36-.16,2.47-.27,3.24-.32A5.66,5.66,0,0,1,333.24,131.32Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.58,116.61c.13,0,.5.79.44,1.9s-.5,1.91-.63,1.85.07-.87.11-1.88S320.43,116.65,320.58,116.61Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.51,184.08C234,195.28,256,227.71,265,239.31c1.89,2.45,7.4,1.55,9.83-.37,5.78-4.54,15.9-12.44,21.94-16.78a5.55,5.55,0,0,0,1.16-7.91L255,158.5a5.56,5.56,0,0,0-8.16-.71l-20.62,18.83A5.57,5.57,0,0,0,225.51,184.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.9,353.34,253,340.18l5.66-85.65S247.4,234,246.14,229.45s-1.57-17.6-1.57-17.6l7.89,9.15s.22-15.73.22-21c0,0,1.12-19.77,1.31-22.52s3-4.21,4.77-4.21,3.53,3.26,3.53,3.26l2.41,32.35s4-17,5.48-19.27,6.71-3.33,10.22-3.08h.1a3,3,0,0,1,1.37,5.38l-4.63,3.24-1.75,16.23s4.26-14,6.52-15.81,6.27,0,7,2-2,6-2,6l-.76,10s3-4.26,4.49-6.52,5.3,0,5.76,1S293.8,220,293.8,220l-4.52,36.33,1.43,52.31",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.71,308.59s0-.3,0-.9-.05-1.5-.1-2.66c-.07-2.35-.18-5.81-.32-10.3-.26-9-.64-22.06-1.12-38.44h0v0c1.32-10.74,2.83-22.93,4.48-36.33v0h0c.59-2,1.16-4.08,1.69-6.18.27-1.05.53-2.11.75-3.18.11-.54.21-1.08.28-1.62a2.79,2.79,0,0,0,0-.71,2.49,2.49,0,0,0-.49-.56,5.52,5.52,0,0,0-2.93-1.26,2.14,2.14,0,0,0-1.47.36,5.12,5.12,0,0,0-1,1.27l-4,5.75-.47.69.06-.83c.23-3.11.49-6.55.75-10v-.06l0-.05a16.6,16.6,0,0,0,1.73-3.35,5.18,5.18,0,0,0,.35-1.8,2.26,2.26,0,0,0-.72-1.57,5.74,5.74,0,0,0-3.32-1.62,3.23,3.23,0,0,0-3.27,1.27,21.61,21.61,0,0,0-1.81,3.52c-.51,1.23-1,2.48-1.47,3.76-.93,2.54-1.79,5.14-2.61,7.77l-.48-.1c.55-5.1,1.15-10.62,1.75-16.22V195l.1-.06,4.38-3.07a2.84,2.84,0,0,0,1.38-2,2.81,2.81,0,0,0-.69-2.3,2.88,2.88,0,0,0-2.27-.86,18.5,18.5,0,0,0-2.68.12,15.09,15.09,0,0,0-5.16,1.48,4.12,4.12,0,0,0-1.85,1.77,20.34,20.34,0,0,0-1,2.55c-.56,1.75-1.07,3.54-1.55,5.34q-1.45,5.4-2.74,10.92l-.39,1.63-.13-1.67c-.32-4.36-.67-9-1-13.75q-.71-9.39-1.39-18.6l0,.11a8.74,8.74,0,0,0-2.18-2.7c-.88-.74-2.1-.39-3.12.09a4.45,4.45,0,0,0-2.27,2.39,5,5,0,0,0-.27,1.67l-.11,1.78q-.41,7.08-.82,14c-.12,2.31-.31,4.61-.37,6.89s0,4.56-.07,6.83q-.07,6.78-.14,13.38v.66l-.43-.5L244.39,212l.42-.17c.12,4.06.32,8.07.7,12a34.66,34.66,0,0,0,.92,5.75,50.18,50.18,0,0,0,2.26,5.28c3.32,6.86,6.81,13.36,10.18,19.57l0,0v.06c-2.68,39.51-4.73,69.79-5.8,85.65v0c1.61,4.41,2.82,7.7,3.63,9.9.39,1.09.69,1.91.89,2.46s.28.83.28.83l-.32-.81-.93-2.45c-.83-2.19-2.06-5.47-3.72-9.87h0v0c1-15.86,3-46.15,5.54-85.66l0,.11c-3.38-6.21-6.88-12.7-10.22-19.58a48.18,48.18,0,0,1-2.29-5.34,33.6,33.6,0,0,1-1-5.83c-.39-3.94-.59-7.95-.71-12l0-.68.45.52,7.89,9.15-.44.16q.07-6.62.14-13.4,0-3.39.07-6.82c.05-2.29.24-4.59.36-6.9q.41-6.94.82-14l.1-1.77a5.83,5.83,0,0,1,.3-1.82,5.06,5.06,0,0,1,2.53-2.68,5.82,5.82,0,0,1,1.79-.55,2.41,2.41,0,0,1,1,.07,3.09,3.09,0,0,1,.87.44,9.36,9.36,0,0,1,2.34,2.87l0,.05v.06q.69,9.19,1.39,18.59c.35,4.71.7,9.39,1,13.75l-.51,0q1.31-5.52,2.75-10.94c.48-1.8,1-3.59,1.56-5.36a20.47,20.47,0,0,1,1-2.63,4.61,4.61,0,0,1,2.07-2,15.08,15.08,0,0,1,5.34-1.53,18.1,18.1,0,0,1,2.76-.13,3.37,3.37,0,0,1,2.63,1,3.25,3.25,0,0,1,.26,4.06,4,4,0,0,1-1,1l-4.38,3.06.1-.18c-.6,5.61-1.2,11.13-1.76,16.22l-.48-.1q1.23-4,2.62-7.79c.47-1.28,1-2.54,1.49-3.78a22,22,0,0,1,1.86-3.61,3.77,3.77,0,0,1,.72-.78,4,4,0,0,1,.94-.5,4.66,4.66,0,0,1,2.06-.18,6.3,6.3,0,0,1,3.61,1.76,2.82,2.82,0,0,1,.84,1.89,5.85,5.85,0,0,1-.38,2,16.6,16.6,0,0,1-1.79,3.45l0-.11c-.27,3.49-.53,6.93-.76,10l-.41-.15,4-5.73.49-.71a2.74,2.74,0,0,1,.64-.68,2.59,2.59,0,0,1,1.76-.44,6,6,0,0,1,3.18,1.38,2.44,2.44,0,0,1,.6.7,2.52,2.52,0,0,1,0,.94c-.07.56-.17,1.11-.28,1.65-.23,1.09-.49,2.15-.76,3.21-.54,2.1-1.12,4.16-1.7,6.18v0c-1.68,13.4-3.21,25.59-4.55,36.33v0c.41,16.39.74,29.46,1,38.45.1,4.48.18,7.94.23,10.3,0,1.16,0,2.05.05,2.66S290.71,308.59,290.71,308.59Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,239.31a22.15,22.15,0,0,1-.29-3.55c-.11-2.2-.22-5.23-.31-8.59s-.15-6.39-.17-8.59a24.54,24.54,0,0,1,.09-3.56,25,25,0,0,1,.28,3.55c.11,2.2.22,5.23.32,8.59s.15,6.39.16,8.59A25.7,25.7,0,0,1,253,239.31Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.67,204.21a3.56,3.56,0,0,1-1,.53,13.52,13.52,0,0,1-2.9.91,14.84,14.84,0,0,1-4.52.2,3,3,0,0,1-1.31-.49,1.76,1.76,0,0,1-.71-1.33,17.67,17.67,0,0,1,.11-2.89,5.66,5.66,0,0,1,1.06-2.73A3.48,3.48,0,0,1,295.8,197a11.63,11.63,0,0,1,4.49.65A12.08,12.08,0,0,1,303,199a3.4,3.4,0,0,1,.88.68,22.48,22.48,0,0,0-3.74-1.63,12,12,0,0,0-4.31-.52,3,3,0,0,0-2.05,1.22,5.19,5.19,0,0,0-.94,2.5,18.63,18.63,0,0,0-.12,2.77c0,.86.79,1.27,1.59,1.38a15.36,15.36,0,0,0,4.38-.08A30.08,30.08,0,0,0,302.67,204.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.38,226a10.49,10.49,0,0,1-2.71,0,30.81,30.81,0,0,1-12.49-3.59,10.05,10.05,0,0,1-2.27-1.47,21,21,0,0,1,2.43,1.14,40.67,40.67,0,0,0,6,2.29,39.48,39.48,0,0,0,6.32,1.26A23.27,23.27,0,0,1,417.38,226Z",
    style: {
      fill: "#ff9a6c"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyCall);
export default __webpack_public_path__ + "static/media/emergency_call.7edba7e6d8d402446e4487f72d76ef02.svg";
export { ForwardRef as ReactComponent };